module.exports = __webpack_public_path__ + "static/media/worldwide_manufacturing_suppliers_vendors_business_network_map.707a819e.png";